<div class="milestones-card">
  <div class="milestones-header">
    <div class="header-left">
      <div class="icon-circle">
        <img src="../../../assets/images/Milestoneicon.png" alt="Milestone Icon" onerror="this.style.display='none'">
      </div>
      <div class="header-text">
        <h2>Your Milestones</h2>
        <p>See how far you've come since joining Grad Pilots. Every step you take brings you closer to your High-Ed
          journey.</p>
      </div>
    </div>
    <div class="header-right">
      <div class="member-since"
        style="display: flex; align-items: center; gap: 12px; padding: 12px 16px; background: white; border: 1px solid #E5E7EB; border-radius: 12px;">
        <i class="pi pi-calendar" style="font-size: 1.2rem; color: #000086;"></i>
        <div class="member-text" style="display: flex; flex-direction: column;">
          <span style="font-size: 11px; color: #6B7280;">Member since</span>
          <strong style="font-size: 13px; color: #111;">{{ (memberSince | date:'dd MMM yyyy') || '—' }}</strong>
        </div>
      </div>
    </div>
  </div>

  <div class="stats-row">
    <div class="overall-progress">
      <div class="progress-info">
        <span class="label">Overall Progress</span>
        <span class="value">{{ overallProgress }}%</span>
        <span class="message">You're doing great! Keep going.</span>
        <div class="progress-bar-container">
          <div class="progress-fill" [style.width.%]="overallProgress"></div>
        </div>
      </div>
    </div>

    <div class="stat-boxes">
      <div class="stat-box">
        <div class="stat-icon purple"><i class="pi pi-file-edit"></i></div>
        <div class="stat-data">
          <h3>{{ profileCompletedCount }}</h3>
          <p>Profile Completed</p>
        </div>
      </div>
      <div class="stat-box">
        <div class="stat-icon green"><i class="pi pi-building"></i></div>
        <div class="stat-data">
          <h3>{{ collegesSaved }}</h3>
          <p>Colleges Saved</p>
        </div>
      </div>
      <div class="stat-box">
        <div class="stat-icon blue"><i class="pi pi-shield"></i></div>
        <div class="stat-data">
          <h3>{{ documentsUploaded }}</h3>
          <p>Documents Uploaded</p>
        </div>
      </div>
      <div class="stat-box">
        <div class="stat-icon orange"><i class="pi pi-star"></i></div>
        <div class="stat-data">
          <h3>{{ savedScholarships }}</h3>
          <p>Saved Scholarships</p>
        </div>
      </div>
    </div>
  </div>

  <div class="milestones-content-grid">
    <div class="journey-panel" style="
    padding: 20px;
    border-radius: 12px;
    border: 1px solid #F1F1F1;
">
      <div class="journey-header" style="display: flex; align-items: center; gap: 8px; margin-bottom: 24px;">
        <img src="../../../assets/images/Journeyicon.png" alt="Journey icon" onerror="this.style.display='none'"
          style="width: 24px;">
        <h3 style="margin: 0;">Your Journey So Far</h3>
      </div>

      <!-- TODO: Static timeline as no backend API exists -->
      <div class="timeline" style="top: 20px;">
        <div class="timeline-item" *ngFor="let event of sortedJourneyEvents; let last = last">
          <div class="timeline-marker" [class.completed]="event.completed">
            <i class="pi pi-check" *ngIf="event.completed"></i>
            <div class="inner-dot" *ngIf="!event.completed"></div>
          </div>
          <div class="timeline-connector" *ngIf="!last"></div>
          <div class="timeline-content">
            <div class="event-icon" [style.color]="event.color" [style.backgroundColor]="event.color + '15'">
              <i class="pi {{ event.icon }}"></i>
            </div>
            <div class="event-details">
              <h4>{{ event.title }}</h4>
              <p>{{ event.description }}</p>
            </div>
            <a class="event-link" *ngIf="event.completed" [routerLink]="event.route">{{ event.linkLabel }}</a>
            <span class="event-link disabled" *ngIf="!event.completed">{{ event.linkLabel }}</span>
          </div>
        </div>
      </div>

      <!-- Trophy Banner TODO -->
      <div class="trophy-banner">
        <div class="trophy-icon">
          <i class="pi pi-star-fill"></i>
        </div>
        <div class="trophy-text">
          <p><strong>You're in the top 20%</strong> of students</p>
          <span>based on progress made in the first 60 days.</span>
        </div>
        <button class="explore-colleges-btn" routerLink="/portal/institute-search">Explore Colleges
          &nbsp;&rarr;</button>
      </div>
    </div>

    <div class="side-panels">
      <div class="upcoming-tasks-panel">
        <div class="panel-header">
          <span class="subtitle">DON'T MISS ANY DEADLINES</span>
          <h3>Upcoming Tasks</h3>
        </div>
        <div class="task-list" *ngIf="sortedUpcomingTasks.length; else noTasks">
          <div class="task-item" *ngFor="let task of sortedUpcomingTasks">
            <div class="task-marker"></div>
            <div class="task-info">
              <h4>{{ task.question || 'Task' }}</h4>
              <p>{{ (task.endDate | date:'MMM dd, yyyy') || '—' }}</p>
            </div>
            <div class="task-days">
              <span>{{ daysLeft(task.endDate) }}d</span>
            </div>
          </div>
        </div>
        <ng-template #noTasks>
          <div class="tasks-empty-state">
            <img src="../../../assets/images/upcoming-tasks-empty.svg" alt="No upcoming tasks">
            <p>You're all caught up! No upcoming tasks right now.</p>
          </div>
        </ng-template>
        <button class="view-all-btn" *ngIf="sortedUpcomingTasks.length">View full schedule &rarr;</button>
      </div>

      <div class="impact-panel">
        <h3>Your Impact</h3>
        <div class="impact-icon-container">
          <img src="../../../assets/images/Trophyicon.png" alt="Trophy"
            onerror="this.src='../../../assets/images/graduation-cap.png'">
        </div>
        <div class="impact-stats">
          <div class="impact-stat">
            <div class="icon"><i class="pi pi-file text-blue-500"></i> Profile completed</div>
            <div class="value text-blue-600">100%</div>
            <div class="sub">Epic Profile</div>
          </div>
          <div class="impact-stat">
            <div class="icon"><i class="pi pi-bolt text-yellow-500"></i> Consistency Streak</div>
            <div class="value text-yellow-500">{{ consistencyStreak }} {{ consistencyStreak === 1 ? 'Day' : 'Days' }}
            </div>
            <div class="sub">{{ streakMessage }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>